<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Track Progress
        </v-card-title>
        <v-card-text>
          <div v-for="(level, index) in form.pointRange" :key="index">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <h4 style="display: inline">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.pointRange.length > 1"
                  icon
                  class="ml-2"
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.min_liters"
                  label="Min Liters"
                  outlined
                  :error-messages="errors.min_liters"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.max_liters"
                  label="Max Liters"
                  outlined
                  :error-messages="errors.max_liters"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.points_per_liter"
                  label="Points per Liter"
                  outlined
                  :error-messages="errors.points_per_liter"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Track Progress
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "TrackProgressCreatePage",
  data() {
    return {
      form: {
        pointRange: [
          {
            min_liters: null,
            max_liters: null,
            points_per_liter: null,
          },
        ],
      },
      isLoading: false,
    };
  },
  methods: {
    addLevel() {
      this.form.pointRange.push({
        min_liters: null,
        max_liters: null,
        points_per_liter: null,
      });
    },
    removeLevel(index) {
      this.form.pointRange.splice(index, 1);
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/transporter_custom_points", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
